import clsx from 'clsx';

import { Button, Text, Types } from '@marriott/mi-ui-library';
import { StyledOverviewTab } from './OverviewTab.styles';
import { useEffect, useState, useContext } from 'react';
import { MaxCharCount, defaultENUS } from '../../../modules/utils/constants';
import { outletDetailsState, useStore } from '../../../modules/store/outletDetailsStore';
import { PageParamsContext } from '../../../modules/context';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OverviewTab = (props: any) => {
  const [showMore, setIsShowMore] = useState(false);
  const michelinTitle = useStore((state: outletDetailsState) => state.michelinTitle);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [awardsList, setAwardsList] = useState<any>([]);
  const { currentLocale } = useContext(PageParamsContext);

  useEffect(() => {
    let updatedAwardsList = [];
    if (michelinTitle) updatedAwardsList.push(michelinTitle);
    if (props?.outletDetails?.awards?.awards && props?.outletDetails?.awards?.awards?.length > 0)
      updatedAwardsList = [...updatedAwardsList, ...props.outletDetails.awards.awards];
    setAwardsList(updatedAwardsList);
  }, [michelinTitle, props?.outletDetails?.awards?.awards]);

  const handleOnClick = () => {
    setIsShowMore(!showMore);
  };

  // const description = filteredOutletDetails?.description?.length
  //   ? filteredOutletDetails?.description
  //   : props?.shortDescription?.length
  //   ? props?.shortDescription
  //   : '';
  let fallbackDesc = `${props?.description}`;
  fallbackDesc = fallbackDesc.replace(/\[.*?\]/, props?.outletDetails?.basicInformation?.name);
  const hotelName = props?.outletDetails?.properties?.edges[0]?.node?.property?.basicInformation?.brand?.name;

  fallbackDesc = fallbackDesc.replace(/\[.*?\]/, hotelName);

  const description =
    currentLocale === defaultENUS && props?.outletDetails?.basicInformation?.longDescription?.length
      ? props?.outletDetails?.basicInformation?.longDescription
      : props?.outletDetails?.basicInformation?.shortDescription || fallbackDesc;
  return (
    <StyledOverviewTab>
      <Text
        customClass={clsx(
          'overview-description t-font-alt-s text-left'
          // !showMore ? 'overview-short-description' : '',
          // showMore ? 'overview-full-description' : ''
        )}
        fontSize={Types.size.small}
        data-testid="overview-description-div"
        element={Types.tags.paragraph}
        copyText={
          description.length <= MaxCharCount || showMore ? description : description.slice(0, MaxCharCount) + '[...]'
        }
      ></Text>
      {description.length > MaxCharCount ? (
        <Button
          type={Types.ButtonTypeVariation.Button}
          className="show-more-button py-1 px-0 m-0 mt-3 t-font-alt-s"
          callback={handleOnClick}
        >
          <span className={clsx('t-font-s', 'show-more-text')}>
            {showMore ? props?.seeLessLabel || '' : props?.seeMoreLabel || ''}
          </span>
          <span className={clsx('show-more-icon', showMore ? 'icon-dropdown-up' : 'icon-dropdown-down')}></span>
        </Button>
      ) : (
        ''
      )}

      {props?.awardsLabel && awardsList && awardsList?.length > 0 && (
        <div className="mt-4">
          <div className="col m-icon-text p-0 mb-2">
            <span className={clsx(props?.iconPathAwards, ' icon-s mr-2')}></span>
            <span className="t-label-alt-s">{props?.awardsLabel}</span>
          </div>
          {awardsList?.length > 1 ? (
            <ul className="ml-1 pl-3">
              {awardsList?.map((award: string) => (
                <li className="t-font-alt-s">{award}</li>
              ))}
            </ul>
          ) : (
            <Text
              customClass={'t-font-alt-s'}
              fontSize={Types.size.small}
              element={Types.tags.span}
              copyText={awardsList[0]}
            ></Text>
          )}
        </div>
      )}
    </StyledOverviewTab>
  );
};
